import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrReconsideration } from '../../../../../../shared/types/modules/pqr';
import { PqrReconsiderationProps } from './props';
import {
    asyncGetParamByCode,
    asyncGetParams,
} from '../../../../../../services/param.service';

export const usePqrReconsideration = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrReconsiderationProps) => {
    const [replicas, setReplicas] = useState<ISelect[]>([]);
    const [replicaParam, setReplicaParam] = useState<ISelect>();

    const onSubmit = (data: PqrReconsideration) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(replicaParam?.id?.toString()),
        onSubmit,
    });

    useEffect(() => {
        formik.validateField('observations');
        formik.validateField('pqrReplica');
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        if (!formik.values.hasReconsideration) {
            formik?.setFieldValue('replica', '');
            formik?.setFieldValue('pqrReplica', '');
            formik?.setFieldValue('observations', '');
        }
    }, [formik.values.hasReconsideration]);

    useEffect(() => {
        if (formik?.values.replica !== replicaParam?.id) {
            formik?.setFieldValue('pqrReplica', '');
            formik?.setFieldValue('observations', '');
        }
    }, [formik.values.replica]);

    useEffect(() => {
        formik?.setFieldValue('hasReconsideration', true);
        formik?.setFieldValue('replica', data?.replica || '');
        formik?.setFieldValue('pqrReplica', data?.pqrReplica || '');
        formik?.setFieldValue('observations', data?.observations || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_REPLICA).then((items) =>
            setReplicas(items)
        );
        asyncGetParamByCode(`${ParamEnum.PQR_REPLICA}_RPC`).then((item) =>
            setReplicaParam(item)
        );
    }, []);

    return {
        formik,
        replicas,
        replicaParam,
    };
};
